import * as Yup from 'yup';

export const onboardingStepperValidationForm: Record<number, any> = {
    0: Yup.object().shape({
        companyName: Yup.string().required('Please, provide the company name'),
    }),
    1: Yup.object().shape({
        contactFirstName: Yup.string().required(
            'Please, provide the contact first name'
        ),
        contactLastName: Yup.string().required(
            'Please, provide the contact last name'
        ),
        tempPassword: Yup.string().trim().required(
            'Please enter the temporary password from your invitation email'
        ),
    }),
};
